import { Ds, Tokens } from "@accurx/design";
import styled from "styled-components";

const { COLOURS } = Tokens;

export const StyledTableHeaderButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background-color: transparent;
    border: none;

    & {
        color: ${COLOURS.greyscale.stone};
    }

    &:hover,
    &:focus {
        color: ${COLOURS.greyscale.metal};
    }
`;

export const StyledTooltipTrigger = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 0;
    border-radius: 50px;

    svg {
        font-size: 32px;
        color: ${COLOURS.greyscale.white};
    }

    width: 32px;
    height: 32px;
`;

export const StyledTooltipContentWrapper = styled(Ds.Text)`
    max-width: 15rem;
`;
